import React from "react";
import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ForfaitInclus() {
  const { t } = useTranslation();
  const items = t("tarifs.includedItems", { returnObjects: true }) || [];
  const mid = Math.ceil(items.length / 2);
  const left = items.slice(0, mid);
  const right = items.slice(mid);

  const Row = ({ text }) =>
  <div className="flex items-start gap-4 py-5 border-b border-[#CCCCCC]">
      <span className="shrink-0 w-6 h-6 rounded-full bg-[#0985D8] flex items-center justify-center text-white mt-0.5">
        <Check className="w-3.5 h-3.5" strokeWidth={3} />
      </span>
      <p className="text-[#1A1A1A] [font-family:'Poppins',_sans-serif] text-base md:text-lg leading-snug">
        {text}
      </p>
    </div>;


  return (
    <section className="py-20 px-6 bg-[#f5f9fd]">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-bold mb-10 md:mb-14 [font-family:'Playfair_Display',_serif] tx-gradient-text">
          {t("tarifs.includedTitle")}
        </h2>
        <div className="grid md:grid-cols-2 gap-x-12 md:gap-x-16">
          <div>
            {left.map((it, i) =>
            <Row key={i} text={it} />
            )}
          </div>
          <div>
            {right.map((it, i) =>
            <Row key={i} text={it} />
            )}
          </div>
        </div>
      </div>
    </section>);

}